<div class="content">
  <div class="wz-head">
    <span class="wz-eyebrow">World Creation Wizard</span>
    <h2 class="wz-title">How much <span class="gold">AI</span>?</h2>
  </div>

  <p class="wz-lead">Pick how your world gets filled in. You can edit everything afterwards, whichever you choose.</p>

  <div class="am-options">
    <!-- Manual -->
    <button type="button" class="am-card" (click)="selectMode(AiGenerationMode.Manual)">
      <span class="am-top">
        <span class="am-cost is-free">Free</span>
        <span class="am-steps">1 step</span>
      </span>
      <span class="am-name">Manual</span>
      <span class="am-tag">"A stubbed wiki"</span>
      <span class="am-best">For creators who want to write every word themselves.</span>
      <ul class="am-list">
        <li>Every wiki page created as a clean template, ready to write.</li>
        <li>One AI world lore page. No images, no further AI.</li>
      </ul>
      <span class="am-choose">Choose Manual <span aria-hidden="true">→</span></span>
    </button>

    <!-- AI Assist -->
    <button type="button" class="am-card" (click)="selectMode(AiGenerationMode.AiAssisted)">
      <span class="am-top">
        <span class="am-cost">1 credit</span>
        <span class="am-steps">7 steps</span>
      </span>
      <span class="am-name">AI Assist</span>
      <span class="am-tag">"Fast. Cohesive. Fully realised."</span>
      <span class="am-best">For getting a world ready quickly with a solid story structure.</span>
      <ul class="am-list">
        <li>Answer a few questions on theme, tone and type.</li>
        <li>Set global themes, influences, tensions and factions.</li>
        <li>AI writes connected culture, religion, state and province lore.</li>
      </ul>
      <span class="am-choose">Choose AI Assist <span aria-hidden="true">→</span></span>
    </button>

    <!-- Guided -->
    <button type="button" class="am-card" (click)="selectMode(AiGenerationMode.Guided)">
      <span class="am-top">
        <span class="am-cost">1 credit</span>
        <span class="am-steps">12 steps</span>
      </span>
      <span class="am-name">Guided</span>
      <span class="am-tag">"You give the details, AI adds depth"</span>
      <span class="am-best">For creators who want a real say while moving fast.</span>
      <ul class="am-list">
        <li>Everything in AI Assist.</li>
        <li>Optional notes for each culture, religion, state and province.</li>
        <li>AI builds deep, layered lore around your input.</li>
      </ul>
      <span class="am-choose">Choose Guided <span aria-hidden="true">→</span></span>
    </button>
  </div>

  <div class="wz-actions">
    <button type="button" class="btn btn-dark" (click)="onBack()">Back</button>
  </div>
</div>
